import AWS from 'aws-sdk';
import { isFunction } from 'lodash';

class Uploader {
  constructor() {
    AWS.config.update({
      region: 'us-east-1',
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'us-east-1:bebc241a-a22a-4fec-8085-cb22158c2ace',
      }),
    });

    this.s3 = new AWS.S3();
  }

  uploadImage(payload, cbPercent) {
    let s3 = this.s3;
    return new Promise(function (resolve, reject) {
      const encodedImage = payload.file.replace('data:*/*;base64,', '').replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '');
      const decodedImage = Buffer.from(encodedImage, 'base64');

      const params = {
        Body: decodedImage,
        Bucket: 'truelifeorg',
        Key: `resources/${new Date().getTime().toString()}_${payload.fileName}`,
        ACL: 'public-read' /* This makes the image public, but only works if your S3 bucket allows public access */,
        ContentType: payload.contentType /* This is important to handle jpg vs png etc */,
      };
      s3.upload(params, function (err, data) {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      }).on('httpUploadProgress', function (progress) {
        if (isFunction(cbPercent)) {
          cbPercent(Math.round((progress.loaded / progress.total) * 100));
        }
      });
    });
  }

  uploadVideoFile(payload, cbPercent) {
    const s3 = this.s3;
    const key = `videos/${new Date().getTime().toString()}_${payload.name}`;
    const uploadBucket = 'truelifeorg-uploads';
    const outputBucket = 'truelifeorg'; // Lambda copies videos here
    console.log('Uploading video:', payload.name, 'Type:', payload.type);
    return new Promise((resolve, reject) => {
      const params = {
        Body: payload,
        Bucket: uploadBucket,
        Key: key,
        ACL: 'public-read',
        ContentType: payload.type,
      };
      s3.upload(params, (err, data) => {
        if (err) {
          console.error('S3 Upload Error:', err);
          console.error('Error Code:', err.code);
          console.error('Error Message:', err.message);
          console.error('Status Code:', err.statusCode);
          
          // Create detailed error message
          let errorMessage = err.message;
          if (err.code === 'CredentialsError' || err.code === 'InvalidAccessKeyId') {
            errorMessage = 'AWS credentials are invalid or expired. Please contact support.';
          } else if (err.code === 'NetworkingError') {
            errorMessage = 'Network error during upload. Please check your connection and try again.';
          } else if (err.statusCode === 403) {
            errorMessage = 'Access denied to S3 bucket. Please contact support.';
          }
          
          reject(new Error(errorMessage));
        } else {
          console.log('Upload successful:', data);
          // Return URL pointing to OUTPUT bucket where Lambda transcodes the file to .mp4
          const outputKey = key.replace(/\.[^.]+$/, '.mp4');
          const outputUrl = `https://${outputBucket}.s3.amazonaws.com/${outputKey}`;
          resolve({ ...data, Location: outputUrl });
        }
      }).on('httpUploadProgress', progress => {
        if (typeof cbPercent === 'function') {
          cbPercent(Math.round((progress.loaded / progress.total) * 100));
        }
      });
    });
  }

  deleteS3File(url) {
    let s3 = this.s3;
    return new Promise((resolve, reject) => {
      const tlBucket = 'https://truelifeorg.s3.amazonaws.com/';
      if (!url.includes(tlBucket)) {
        reject(new Error('Invalid s3 url!'));
      }

      s3.deleteObject(
        {
          Bucket: 'truelifeorg',
          Key: url.replace('https://truelifeorg.s3.amazonaws.com/', ''),
        },
        (err, data) => {
          return err ? reject(err) : resolve(data);
        },
      );
    });
  }
}

export default Uploader;
